import { GET_PROGRESS_LIST, GET_PROGRESS_LIST_FAIL, GET_PROGRESS_LIST_SUCCESS } from './constants';

export const getProgressList = payload => {
  return {
    type: GET_PROGRESS_LIST,
    payload
  };
};

export const getProgressListSuccess = payload => {
  return {
    type: GET_PROGRESS_LIST_SUCCESS,
    payload
  };
};

export const getProgressListFail = error => {
  return {
    type: GET_PROGRESS_LIST_FAIL,
    error
  };
};
